<template>
    <div class="main">
        <div class="tipbox">
             <div class="back global_pointer" @click="goBack">
                <img src="@/assets/imgs/nav_left_icon_back.png"/>
             </div>
            <span class="states" v-if="detailData.userOrderStatus != 1">{{ changeState(detailData.userOrderStatus2) }}</span>
            <span class="times" v-if="detailData.userOrderStatus == 1"
                >{{ orderLan.orderTimePre }} {{ detailData.userOrderStatus == 1 ? times : '' }} {{ orderLan.orderTime }}</span>
        </div>
        <Address :addressData="addressData" />
        <GoodsList :goodsList="goodsList" :showLogistics="orderData.orderStatus==4" :showTip="false" />
        <OrderPrice :orderData="orderData"/>
        <div class="real-price">
            <div>{{ orderLan.realMoney }}</div>
            <div class="payprice">
                {{ detailData.payAmountMoney ? detailData.payAmountMoney.symbol : '' }}
                {{ detailData.payAmountMoney ? $currencyFormatter(detailData.payAmountMoney.number) : '' }}
            </div>
        </div>
        <ul class="orderbox">
            <li>{{ orderLan.orderNo }} {{ detailData.orderNo }}</li>
            <li>{{ orderLan.passOrderTime }}：{{ changeTimer(detailData.createTime) }}</li>
            <li>{{ orderLan.payOrderTime }}：{{ changeTimer(detailData.payTime) }}</li>
            <li>
                <div>{{ orderLan.orderMessage }}：</div>
                <div class="ordercontent">{{ detailData.customerNote }}</div>
            </li>
            <li
                class="footbox"
                v-if="
                    detailData.orderStatus === 1 ||
                        detailData.orderStatus === 3 ||
                        detailData.orderStatus === 4 ||
                        detailData.orderStatus === 7 ||
                        detailData.orderStatus === 8
                "
            >
                <!-- <div
                    @click="chatService"
                    class="btnbox cancelbox"
                >
                    {{ orderLan.chatService }}
                </div> -->
                <div
                    @click="cancelOrder"
                    class="btnbox cancelbox global_pointer"
                    v-if="detailData.orderStatus === 1"
                >
                    {{ orderLan.cancelOrder }}
                </div>
                <div @click=" nowpayMoney " class="btnbox nowpay global_pointer" v-if="detailData.orderStatus === 1">
                    {{ orderLan.nowPay }}
                </div>
                <div @click="confirmOrder" class="btnbox global_pointer" v-if="detailData.orderStatus === 4">
                    {{ orderLan.confirmShop }}
                </div>
                <div
                    @click="deleteOrder"
                    class="btnbox global_pointer"
                    v-if="detailData.orderStatus === 7 || detailData.orderStatus === 8"
                >
                    {{ orderLan.delOrder }}
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import Address from '@/components/order/address.vue'
import GoodsList from '@/components/order/goodsList.vue'
import OrderPrice from '@/components/order/orderPrice.vue'
import api from "@/api/api_list";

export default {
    components: {
        Address,
        GoodsList,
        OrderPrice
    },
    data() {
        return {
            times: '',
            detailData: {}, // 详情数据
            addressData: {}, // 地址
            orderData: {}, // 价格优惠
            goodsList: [], // 商品列表
            orderLan: this.$t("message.order"),
            leftTime: 0,
            formPay: false,
        }
    },
    computed: {
    },
    created() {
        if (this.$route.query.orderId) {
            this.getDetail()
        }
    },
    methods: {
        // 获取订单详情
        async getDetail() {
            try {
                let { code, result } = await api.get_order_detail({orderId:this.$route.query.orderId})
                if (!code) {
                    this.detailData = result
                    this.leftTime = result.leftTime
                    this.addressData = {
                        consigneeName: result.consigneeName,
                        consigneePhone: result.consigneePhone,
                        consigneeAddress: result.consigneeAddress
                    }
                    this.orderData = {
                        ...result,
                        disRankAmountMoney: result.disRankAmountMoney,
                        totalAmountMoney: result.totalAmountMoney,
                        disTicketAmountMoney: result.disTicketAmountMoney,
                        couponcodeSavePriceMoney: result.disCodeAmountMoney
                    }
                    this.goodsList = result.orderMerchandises
                    if (this.detailData.userOrderStatus == 1 && result.leftTime > 0) {
                        this.changeTime()
                    }
                    if(this.formPay && result.orderStatus == 1){ // 针对从支付结果页面过来做处理
                        this.formPay = false
                        this.$router.push('/repay?orderId=' + this.$route.query.orderId)
                    }
                }
            } catch (error) {

                this.$toast.fail(this.orderLan.getDataFail);
            } finally {
            }
            
        },
        // 联系客服
        chatService () {
            this.$yyb()
        },
        // 取消订单
        async cancelOrder() {
            try {
                const { code } = await api.cacel_order({
                    orderId: this.$route.query.orderId
                })
                if (!code) {
                    this.getDetail()
                }
            } catch (error) {
                this.$toast.fail(this.orderLan.cancelFail);
            }
        },
        // 确认收货
        async confirmOrder() {
            try {
                const { code } = await api.confirm_receipt({
                    orderId: this.$route.query.orderId
                })
                if (!code) {
                    this.getDetail()
                }
            } catch (error) {
                this.$toast.fail(this.orderLan.confirmShopFail);
            }
        },
        // 删除订单
        async deleteOrder() {
            try {
                const { code } = await api.delete_order({
                    id: this.$route.query.orderId
                })
                if (!code) {
                    this.$router.push({ path: '/order_list' })
                }
            } catch (error) {
                this.$toast.fail(this.orderLan.delOrderFail);
            }
        },
        // 状态变化
        changeState(val) {
            switch (val) {
            case 1:
                return this.orderLan.waitPay
            case 2:
                return this.orderLan.orderDetailWaitSent
            case 3:
                return this.orderLan.waitReceive
            case 4:
                return this.orderLan.waitMent
            case 5:
                return this.orderLan.yetMent
            case 6:
                return this.orderLan.fackof
            default:
                return ''
            }
        },
        // 倒计时
        changeTime() {
            let time = setTimeout(this.changeTime, 1000)
            if (this.leftTime <= 0) {
                clearTimeout(time)
                this.getDetail()
                return
            }
            this.leftTime--
            let h = Math.floor((this.leftTime / 60 / 60) % 24)
            let m = Math.floor((this.leftTime / 60) % 60)
            let s = Math.floor(this.leftTime % 60)
            // d = this.checkTime(d);
            h = this.checkTime(h)
            m = this.checkTime(m)
            s = this.checkTime(s)
            this.times = `${h}:${m}:${s}`
        },
        checkTime(i) {
            if (i < 10) {
                i = '0' + i
            }
            return i
        },
        async nowpayMoney() {
			this.$router.push({ path: "/repay", query: { orderId: this.$route.query.orderId } });
        },
        changeTimer(val) {
            return val ? this.$moment(new Date(val)).format('yyyy-MM-DD HH:mm:ss') : ''
        },
        goBack(){
			this.$router.back(-1);
        }
    }
}
</script>

<style lang="less" scoped>
.header {
    padding: 0 12px;
    width: 100%;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .backbtn {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 55px;
        display: flex;
        align-items: center;
        padding: 0 10px 10px 10px;
        .back-img {
            width: 28px;
            height: 28px;
            background: url('https://fr-static.shopshops.top/20200328/Nav_left_icon_back_black@2x.6ab19bd0936426eb.png')
                no-repeat;
            background-size: 100% 100%;
        }
    }
    .title {
        font-size: 15px;
        font-weight: bold;
    }
}
.tipbox {
    padding: 15px 12px 15px 33px;
    line-height: 12px;
         position: relative;
         text-align: left;
     .back{
         position: absolute;
         left: 0px;
         top: 0px;
         display: inline-block;
         padding: 5px;
         
        img{
            width: 28px;
            height: 28px;
        }
      
    }
}
.real-price {
    font-size: 16px;
    color: #161a1a;
    display: flex;
    background: #fff;
    padding: 12px;
    margin-top: 2px;
    div:first-child {
        flex: 1;
        text-align: left;
        font-family: "TradeGothicLT";

    }
    .payprice {
        color: #b4282d;
        font-family: "TradeGothicLT-Bold";
    }
}
.orderbox {
    padding: 12px;
    background: #fff;
    margin-top: 12px;
        font-family: "TradeGothicLT";
    li {
        font-size: 13px;
        color: #5a5a5a;
        padding: 6px 0;
        display: flex;
        .ordercontent {
            flex: 1;
            text-align: left;
        }
    }
    .footbox {
        justify-content: flex-end;
        font-family: "TradeGothicLT";
        div ~ div {
            margin-left: 10px;
        }
        .btnbox {
            padding: 0 10px;
            height: 26px;
            border-radius: 15px;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 0.5px solid #161a1a;
        }
    }
    .cancelbox {
    }
    .nowpay {
        color: #519d9e;
        border: 0.5px solid #519d9e;
    }
}
.states {
    font-size: 13px;
}
.times {
    color: #b4282d;
    font-size: 13px;
    margin-left: 8px;
}

</style>
